import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles } from '@material-ui/core'
import get from 'lodash.get'

import NoPropertyFound from '../components/NoPropertyFound'
import MenuBar from '../components/header/MenuBar'
import SearchBar from '../components/SearchBar'
import SearchBox from '../components/SearchBox'
import FlashMessage from '../components/FlashMessage'
import DetailsModal from '../components/DetailsModal'
import Footer from '../components/Footer'
import * as actions from '../actions'
import * as types from '../constants'
import { isUserLogged, trackPage } from 'utils'
import PropertyList from 'components/PropertyList'
import whoAreweImage from 'images/whoarewe-bg.jpg'
import searchIcon from 'images/search.svg'
import searchwhiteIcon from 'images/search-white.svg'
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { RegisterContainer } from '../features/authentication/containers'
const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  minHeight: {
    minHeight: '100px',
  },
  whoAreConatiner: {
    backgroundImage: `url(${whoAreweImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: '95px 0',
    marginTop: '50px',
    [theme.breakpoints.down('1025')]: {
      padding: '30px 40px',
      marginTop: '30px',
    },

    [theme.breakpoints.down('767')]: {
      padding: '30px 15px',
    },
  },
  whoaretitle: {
    fontSize: 64,
    fontWeight: 500,
    color: '#fff',
    padding: '0 0 50px',
    lineHeight: '100%',
    [theme.breakpoints.down('1025')]: {
      fontSize: 30,
      padding: '0 0 20px',
    },
    [theme.breakpoints.down('767')]: {
      fontSize: 24,
    },
  },
  whoareContent: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  whoareweLeft: {
    flex: '0 0 60%',
    maxWidth: '60%',
    padding: '0 30px 0 0',
    [theme.breakpoints.down('960')]: {
      flex: '0 0 100%',
      maxWidth: '100%',
      padding: '0',
      order: '2',
    },
  },
  whoareweRight: {
    flex: 'none',
    width: '40%',
    order: '1',
    margin: '60px 0 0',
    [theme.breakpoints.down('960')]: {
      margin: '0 0 20px',
      width: '100%',
    },
    '& svg': {
      display: 'none',
    },
    '&.searchBox': {
      maxWidth: '100%',
    },
    '& button': {
      width: 'auto',
      backgroundColor: 'transparent',
      backgroundImage: `url(${searchIcon})`,
      backgroundPosition: 'center',
      border: 'transparent 1px solid',
      backgroundRepeat: 'no-repeat',
      flex: 'none',
      cursor: 'pointer',
      pointerEvents: 'inherit !important',
      '&[disabled]': {
        '&:hover': {
          backgroundColor: 'inherit !important',
          backgroundImage: `url(${searchIcon})`,
        },
      },
      '&:hover': {
        backgroundColor: '#00bcb5',
        backgroundImage: `url(${searchwhiteIcon})`,
      },
      [theme.breakpoints.down('767')]: {
        backgroundSize: '20px',
      },
      '& span': {
        display: 'none',
      },
    },
  },
  whoarepara: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '1.4',
    color: '#fff',
    margin: '0',
    [theme.breakpoints.down('767')]: {
      fontSize: 16,
    },
  },
  gridList: {
    width: 'auto',
    margin: '0px auto',
    maxWidth: '1240px',
    [theme.breakpoints.down('1240')]: {
      maxWidth: '97%',
    },
  },
  signupContainer: {
    minHeight: '100px',
    margin: '85px auto 0 auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    backgroundColor: '#fff',
    maxWidth: '515px',
  },
})

class MainPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      showDetail: false,
      showSettings: false,
    }
  }

  componentDidMount() {
    trackPage(window.location.pathname)
    window.scrollTo(0, 0)
    if (this.props.location !== undefined) {
      if (this.props.location.pathname.indexOf('settings') > -1) {
        this.setState({
          showSettings: true,
        })
      } else {
        const { showDetail } = this.state
        this.setState({
          showDetail: !showDetail,
        })
      }
    }
    const { actions, user } = this.props
    if (!isUserLogged(user)) {
      actions.fetchUserLocation()
    } else {
      if (isUserLogged(user)) {
        geocodeByAddress(user.personalData.get('location'))
          .then(results => getLatLng(results[0]))
          .then(latLng => actions.fetchUserLocation(latLng))
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions, user } = this.props
    const prevID = get(prevProps, 'match.params.propertyID', 0)
    const currID = get(this.props, 'match.params.propertyID', 0)
    if (isUserLogged(this.props.user) !== isUserLogged(prevProps.user)) {
      if (isUserLogged(user)) {
        geocodeByAddress(user.personalData.get('location'))
          .then(results => getLatLng(results[0]))
          .then(latLng => actions.fetchUserLocation(latLng))
      }
    }
    // Check for an empty location
    // if (this.props.statusUpdate !== prevProps.statusUpdate) {
    // if (isUserLogged(user)) {
    //   console.log('here logged')
    //   geocodeByAddress(user.personalData.get('location')).then(results => getLatLng(results[0]))
    //   .then(latLng => actions.fetchUserLocation(latLng))
    // } else {
    //   console.log('here not logged')
    //   actions.fetchUserLocation()
    // }
    // }

    if (currID > 0 && prevID !== currID) {
      this.setState({
        showDetail: true,
      })
    }
    // Browser back button handling for modal popup
    window.onpopstate = e => {
      if (this.props.location === undefined) {
        this.setState({
          showDetail: false,
        })
      }
    }
    if (prevState.showSettings !== this.state.showSettings && typeof this.props.user.get('token') === 'undefined') {
      actions.showFlashMessage(false, types.MESSAGE.LOGIN_ERROR_MESSAGE)
    }
  }

  toggleDetail() {
    const { history } = this.props
    if (this.state.showDetail) {
      history.push(`${types.ROUTES_PATH.HOME}`)
    }

    this.setState(prevState => ({
      showDetail: !prevState.showDetail,
    }))
  }

  setShowSettings = () => {
    this.setState({
      showSettings: false,
    })
  }

  handleFlashMessageClick = () => {
    this.props.actions.showSignInModal(true)
  }

  render() {
    const propertyID = get(this.props, 'match.params.propertyID', 0)
    const { showDetail, showSettings } = this.state
    const { isPropertiesLoading, listingsCount, classes } = this.props
    const { user } = this.props
    const isLoggedIn = isUserLogged(user)

    const properties = this.props.properties ? this.props.properties.toArray() : []

    return (
      <Grid container>
        {/* <NetworkIssue /> */}
        <Grid item xs={12}>
          <MenuBar hidePremium={true} showSettings={showSettings} setShowSettings={this.setShowSettings} />
        </Grid>
        <Grid item xs={12}>
          <SearchBar />
        </Grid>
        <Grid item xs={12} lg={isLoggedIn ? 12 : 7} className={classes.minHeight} style={{ paddingLeft: '7em' }}>
          {properties.length > 0 ? (
            <PropertyList title="New Listings" isLoading={isPropertiesLoading} properties={properties} onSelect={() => this.toggleDetail()} />
          ) : (
            listingsCount === 0 && <NoPropertyFound noResult={`${types.MESSAGE.NO_RESULT_FOUND}`} />
          )}

          <DetailsModal
            propertyRemoved={id => this.propertyRemoved(id)}
            listing
            open={showDetail}
            onClose={() => this.toggleDetail()}
            propertyId={propertyID}
            noMap
          />
        </Grid>
        {!isLoggedIn && (
          <Grid item lg={5} className={classes.signupContainer}>
            <RegisterContainer showOnMainPage hidePremium history={this.props.history} {...this.props.actions} />
          </Grid>
        )}
        <Grid item xs={12} className={classes.whoAreConatiner}>
          <div className={classes.gridList}>
            <div className={classes.whoaretitle}>Who Are We?</div>
            <div className={classes.whoareContent}>
              <div className={classes.whoareweLeft}>
                <p className={classes.whoarepara}>
                  Residential properties for rehab to sell or rent exclusively for real estate investors. Whether you’re an experienced real estate investor or
                  just getting started, DealVestors™ offers you a unique way to find fast, fair and smart deals on residential or rental investment properties.
                  DealVestors™ connects you with other real estate investors who are in the business of finding and reselling properties. We do the groundwork
                  of locating investment properties that are ripe for renovation, are priced below market, or have the potential for healthy cashflow. You
                  simply pick the property that’s right for your investment needs. A smarter, easier, faster way to find great deals on investment properties.
                  That’s DealVestors™.
                </p>
              </div>
              <div className={classes.whoareweRight}>
                <SearchBox />
              </div>
            </div>
          </div>
        </Grid>
        <Footer />

        <FlashMessage handleClick={this.handleFlashMessageClick} />
      </Grid>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}
function mapStateToProps(state) {
  return {
    user: state.user,
    properties: state.listings.get('data'),
    listingsCount: state.listings.get('count'),
    isPropertiesLoading: state.listings.get('isLoading'),
    similarProperties: state.similarProperties.get('data'),
    statusUpdate: state.user.statusUpdate,
  }
}

const mainpage = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage)
export default withStyles(styles)(mainpage)



// WEBPACK FOOTER //
// ./src/containers/MainPage.js